import {
  SearchStateType,
  ILocation,
  SearchStateTypeWithDates,
  SelectPassengerType,
  SearchRequestType,
} from "../../../../Orchestrator/Types/Index";
import { IFmlmView } from "../../../../Orchestrator/Types/Interface/IFmlmView";
import {
  FmlmLocation,
  LocationPermission,
} from "../../../../Orchestrator/Types/Types/FmlmSearch/FmlmSearchType";

export class SearchContext {
  public stepRoute: string | undefined = "";
  public routeTo: string[] = [];
  public nextTo: string[] = [];
  public homeData: string = "";
  public listOfStops: any[] = [];
  public searchStateAtom!: Partial<SearchStateType>;

  public searchFrom: string = "";
  public field: string = "";
  public outsideClick: boolean = false;
  public isOriginSelected: boolean = false;
  public isPassengerDropdownOpen: boolean = false;
  public selectedLocation!: ILocation;
  public searchStateTypeWithDates!: SearchStateTypeWithDates;
  public selectPassengerType!: SelectPassengerType;
  public searchRequestType!: SearchRequestType;
  public offerResult: any[] = [];
  public locationMapVisible: boolean = false;
  public locationData: any[] = [];
  public locationPermission!: LocationPermission;
  public currentLocation!: FmlmLocation;
  public reverseGeocodeLocation: any;
  public selectedLocationForOrigin!: FmlmLocation;
  public selectedLocationForDestination!: FmlmLocation;
  public isTimerVisible: boolean = false;

  constructor() {}
}
